var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.625 11.25H16.875C17.1734 11.25 17.4595 11.3685 17.6705 11.5795C17.8815 11.7905 18 12.0766 18 12.375C18 12.6734 17.8815 12.9595 17.6705 13.1705C17.4595 13.3815 17.1734 13.5 16.875 13.5H5.625C5.32663 13.5 5.04048 13.3815 4.8295 13.1705C4.61853 12.9595 4.5 12.6734 4.5 12.375C4.5 12.0766 4.61853 11.7905 4.8295 11.5795C5.04048 11.3685 5.32663 11.25 5.625 11.25ZM5.625 15.75H16.875C17.1734 15.75 17.4595 15.8685 17.6705 16.0795C17.8815 16.2905 18 16.5766 18 16.875C18 17.1734 17.8815 17.4595 17.6705 17.6705C17.4595 17.8815 17.1734 18 16.875 18H5.625C5.32663 18 5.04048 17.8815 4.8295 17.6705C4.61853 17.4595 4.5 17.1734 4.5 16.875C4.5 16.5766 4.61853 16.2905 4.8295 16.0795C5.04048 15.8685 5.32663 15.75 5.625 15.75ZM12.375 6.75H16.875C17.1734 6.75 17.4595 6.86853 17.6705 7.0795C17.8815 7.29048 18 7.57663 18 7.875C18 8.17337 17.8815 8.45952 17.6705 8.6705C17.4595 8.88147 17.1734 9 16.875 9H12.375C12.0766 9 11.7905 8.88147 11.5795 8.6705C11.3685 8.45952 11.25 8.17337 11.25 7.875C11.25 7.57663 11.3685 7.29048 11.5795 7.0795C11.7905 6.86853 12.0766 6.75 12.375 6.75ZM4.21088 8.90325L0 4.6935L1.59075 3.10162L4.21088 5.72175L9.9315 0L11.5234 1.59075L4.21088 8.90325Z",
    fill: "#1098F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingTask);
export default __webpack_public_path__ + "static/media/pending-task.67f48bab32934553d1f37a5e82ce88bc.svg";
export { ForwardRef as ReactComponent };